<div class="logo">
    <!-- <div class="picture" *ngIf="!(isLoading | async)" alt="AntemetA" [routerLink]="'/'">
    </div> -->
    <div class="logo-svg-container " *ngIf="!(isLoading | async)">
        <svg class="logo-svg" viewBox="0 0 102.25 102.25" preserveAspectRatio="xMaxYMax">
            <g>
                <path d="M30.428,26.192c0,11.132,9.063,20.2,20.195,20.2c11.139,0,20.196-9.068,20.196-20.2
			c0-11.14-9.057-20.201-20.196-20.201C39.491,5.991,30.428,15.052,30.428,26.192z M33.277,26.192
			c0-9.564,7.782-17.354,17.346-17.354c9.571,0,17.354,7.789,17.354,17.354c0,9.567-7.783,17.351-17.354,17.351
			C41.059,43.542,33.277,35.759,33.277,26.192z" />
                <path d="M8.985,49.762c0,11.142,9.063,20.2,20.201,20.2c11.143,0,20.2-9.059,20.2-20.2
			c0-11.133-9.057-20.201-20.2-20.201C18.048,29.561,8.985,38.629,8.985,49.762z M11.828,49.762c0-9.568,7.788-17.347,17.357-17.347
			c9.567,0,17.35,7.778,17.35,17.347c0,9.573-7.783,17.355-17.35,17.355C19.616,67.118,11.828,59.335,11.828,49.762z" />
                <path d="M30.428,73.418c0,11.133,9.063,20.196,20.195,20.196c11.139,0,20.196-9.063,20.196-20.196
			c0-11.136-9.057-20.199-20.196-20.199C39.491,53.219,30.428,62.283,30.428,73.418z M33.277,73.418
			c0-9.566,7.782-17.35,17.346-17.35c9.571,0,17.354,7.783,17.354,17.35s-7.783,17.347-17.354,17.347
			C41.059,90.765,33.277,82.985,33.277,73.418z" />
                <path d="M52.125,49.762c0,11.142,9.064,20.2,20.199,20.2c11.139,0,20.203-9.059,20.203-20.2
			c0-11.133-9.064-20.201-20.203-20.201C61.189,29.561,52.125,38.629,52.125,49.762z M54.975,49.762
			c0-9.568,7.783-17.347,17.349-17.347c9.572,0,17.352,7.778,17.352,17.347c0,9.573-7.779,17.355-17.352,17.355
			C62.758,67.118,54.975,59.335,54.975,49.762z" />
                <rect x="46.356" y="28.776" width="2.849" height="41.75" />
                <rect x="52.295" y="28.776" width="2.852" height="41.75" />
                <rect x="29.881" y="51.203" width="41.742" height="2.842" />
                <rect x="29.881" y="45.256" width="41.742" height="2.848" />
            </g>
        </svg>
    </div>
    <div class="loading" *ngIf="isLoading | async">
        <svg preserveAspectRatio="xMidYMid"
             style="margin: auto; background: transparent none repeat scroll 0% 0%; display: block; shape-rendering: auto;"
             width="50px" height="50px" viewBox="0 0 33.333333333333336 33.333333333333336">
            <g transform="translate(-8.333333333333334,-8.333333333333334)">
                <circle fill="color" r="5" cx="37.5" cy="25">
                    <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                             dur="0.75s" begin="-0.9s"></animate>
                    <animate attributeName="fill" repeatCount="indefinite"
                             values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff" times="0;0.1;0.2;0.3;1" dur="0.75s"
                             begin="-0.9s"></animate>
                </circle>
                <circle fill="color" r="5" cx="35.112712429686844" cy="32.34731565365591">
                    <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                             dur="0.75s" begin="-0.8s"></animate>
                    <animate attributeName="fill" repeatCount="indefinite"
                             values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff" times="0;0.1;0.2;0.3;1" dur="0.75s"
                             begin="-0.8s"></animate>
                </circle>
                <circle fill="color" r="5" cx="28.862712429686844" cy="36.88820645368942">
                    <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                             dur="0.75s" begin="-0.7s"></animate>
                    <animate attributeName="fill" repeatCount="indefinite"
                             values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff" times="0;0.1;0.2;0.3;1" dur="0.75s"
                             begin="-0.7s"></animate>
                </circle>
                <circle fill="color" r="5" cx="21.13728757031316" cy="36.88820645368942">
                    <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                             dur="0.75s" begin="-0.6s"></animate>
                    <animate attributeName="fill" repeatCount="indefinite"
                             values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff" times="0;0.1;0.2;0.3;1" dur="0.75s"
                             begin="-0.6s"></animate>
                </circle>
                <circle fill="color" r="5" cx="14.887287570313159" cy="32.34731565365591">
                    <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                             dur="0.75s" begin="-0.5s"></animate>
                    <animate attributeName="fill" repeatCount="indefinite"
                             values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff" times="0;0.1;0.2;0.3;1" dur="0.75s"
                             begin="-0.5s"></animate>
                </circle>
                <circle fill="color" r="5" cx="12.5" cy="25">
                    <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                             dur="0.75s" begin="-0.4s"></animate>
                    <animate attributeName="fill" repeatCount="indefinite"
                             values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff" times="0;0.1;0.2;0.3;1" dur="0.75s"
                             begin="-0.4s"></animate>
                </circle>
                <circle fill="color" r="5" cx="14.887287570313157" cy="17.65268434634409">
                    <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                             dur="0.75s" begin="-0.3s"></animate>
                    <animate attributeName="fill" repeatCount="indefinite"
                             values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff" times="0;0.1;0.2;0.3;1" dur="0.75s"
                             begin="-0.3s"></animate>
                </circle>
                <circle fill="color" r="5" cx="21.137287570313156" cy="13.111793546310581">
                    <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                             dur="0.75s" begin="-0.2s"></animate>
                    <animate attributeName="fill" repeatCount="indefinite"
                             values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff" times="0;0.1;0.2;0.3;1" dur="0.75s"
                             begin="-0.2s"></animate>
                </circle>
                <circle fill="color" r="5" cx="28.86271242968684" cy="13.11179354631058">
                    <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                             dur="0.75s" begin="-0.1s"></animate>
                    <animate attributeName="fill" repeatCount="indefinite"
                             values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff" times="0;0.1;0.2;0.3;1" dur="0.75s"
                             begin="-0.1s"></animate>
                </circle>
                <circle fill="color" r="5" cx="35.11271242968684" cy="17.65268434634408">
                    <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                             dur="0.75s" begin="0s"></animate>
                    <animate attributeName="fill" repeatCount="indefinite"
                             values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff" times="0;0.1;0.2;0.3;1" dur="0.75s"
                             begin="0s"></animate>
                </circle>
            </g>
        </svg>
    </div>
</div>
